/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationTypePostRequest
 */
export interface ConversationTypePostRequest {
    /**
     * Unique identifier for a conversation type.
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    id: string;
    /**
     * A description of what this conversation type is used for.
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    description?: string | null;
    /**
     * If set, all user participants will appear as the same user in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    displayNameSharedByUsers?: string | null;
    /**
     * If set, all workflow participants will appear with this name in the conversation to client participants.
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    displayNameForWorkflowParticipants?: string | null;
    /**
     * A JSON Schema describing the data expected in the conversation.
     * @type {any}
     * @memberof ConversationTypePostRequest
     */
    conversationDataSchema?: any | null;
    /**
     * A handlebars template string used to render the conversation data in a list view. The template can contain placeholders for data in the conversation data schema, or one of the allowed values: conversation_id, conversation_description, conversation_unread_count.
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    conversationDataListItemTemplate: string;
    /**
     * An HTML template to reader the header in the client app which has dynamic values based on the conversation_data
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    clientAppHeaderTemplate?: string | null;
    /**
     * If set, the SMS messages will have this value as sender
     * @type {string}
     * @memberof ConversationTypePostRequest
     */
    smsSenderId?: string | null;
    /**
     * A map of template types to template names. If not provided, system default templates will be used.
     * @type {{ [key: string]: string; }}
     * @memberof ConversationTypePostRequest
     */
    messageTemplates?: { [key: string]: string; } | null;
    /**
     * The number of days conversations of this type will be retained before automatic deletion.
     * @type {number}
     * @memberof ConversationTypePostRequest
     */
    retentionPolicyDays?: number | null;
}

/**
 * Check if a given object implements the ConversationTypePostRequest interface.
 */
export function instanceOfConversationTypePostRequest(value: object): value is ConversationTypePostRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conversationDataListItemTemplate' in value) || value['conversationDataListItemTemplate'] === undefined) return false;
    return true;
}

export function ConversationTypePostRequestFromJSON(json: any): ConversationTypePostRequest {
    return ConversationTypePostRequestFromJSONTyped(json, false);
}

export function ConversationTypePostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationTypePostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'displayNameSharedByUsers': json['display_name_shared_by_users'] == null ? undefined : json['display_name_shared_by_users'],
        'displayNameForWorkflowParticipants': json['displayNameForWorkflowParticipants'] == null ? undefined : json['displayNameForWorkflowParticipants'],
        'conversationDataSchema': json['conversation_data_schema'] == null ? undefined : json['conversation_data_schema'],
        'conversationDataListItemTemplate': json['conversation_data_list_item_template'],
        'clientAppHeaderTemplate': json['client_app_header_template'] == null ? undefined : json['client_app_header_template'],
        'smsSenderId': json['sms_sender_id'] == null ? undefined : json['sms_sender_id'],
        'messageTemplates': json['message_templates'] == null ? undefined : json['message_templates'],
        'retentionPolicyDays': json['retention_policy_days'] == null ? undefined : json['retention_policy_days'],
    };
}

export function ConversationTypePostRequestToJSON(json: any): ConversationTypePostRequest {
    return ConversationTypePostRequestToJSONTyped(json, false);
}

export function ConversationTypePostRequestToJSONTyped(value?: ConversationTypePostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'display_name_shared_by_users': value['displayNameSharedByUsers'],
        'displayNameForWorkflowParticipants': value['displayNameForWorkflowParticipants'],
        'conversation_data_schema': value['conversationDataSchema'],
        'conversation_data_list_item_template': value['conversationDataListItemTemplate'],
        'client_app_header_template': value['clientAppHeaderTemplate'],
        'sms_sender_id': value['smsSenderId'],
        'message_templates': value['messageTemplates'],
        'retention_policy_days': value['retentionPolicyDays'],
    };
}

